<template>
	<div class="b-switch" :class="classes">
		<div
			class="b-switch__label b-switch__label--off"
			@click="() => handleLabelClick(false)"
		>
			<slot name="labelOff">
				{{ label || labelOff }}
			</slot>
		</div>

		<label class="b-switch__switch" tabindex="0">
			<input type="checkbox" v-model="innerModel" :disabled="disabled" />
			<div class="b-switch__handle">
				<BIcon :name="icon" size="16px" />
			</div>
		</label>

		<div
			v-if="labelOn"
			class="b-switch__label b-switch__label--on"
			@click="() => handleLabelClick(true)"
		>
			<slot name="labelOn">
				{{ labelOn }}
			</slot>
		</div>
	</div>
</template>

<script>
import BIcon from "@/components/base/BIcon";

export default {
	name: "b-switch",
	components: {
		BIcon,
	},
	props: {
		value: {
			type: Boolean,
			default: null,
		},
		labelOn: {
			type: String,
			default: "",
		},
		labelOff: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: "Placeholder",
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return [];
		},
		innerModel: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
	methods: {
		handleLabelClick(value) {
			if (this.disabled) {
				return;
			}
			this.$emit("input", value);
		},
	},
};
</script>

<style lang="scss">
.b-switch {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	cursor: pointer;
	position: relative;

	input {
		display: none;
	}
}

.b-switch__label {
	font-size: var(--font-size-xs);
	color: var(--color-neutral-500);
	cursor: pointer;
}

.b-switch__switch {
	width: 52px;
	height: 32px;
	border-radius: 100px;
	padding: 6px;
	background-color: #fff;
	background-color: var(--color-neutral-175);
	transition: var(--transition);
	cursor: pointer;

	&:hover {
		background-color: var(--color-neutral-200);
	}
}

.b-switch__handle {
	--size: 20px;
	--color-background-handle: #fff;
	width: var(--size);
	height: var(--size);
	border-radius: 100px;
	background-color: var(--color-background-handle);
	color: var(--color-neutral-175);
	transition: var(--transition);
	display: flex;
	align-items: center;
	justify-content: center;
}

.b-switch__switch:active {
	.b-switch__handle {
		box-shadow: 0 0 0 2px var(--color-background-handle);
	}
}

.b-switch:has(input:checked) {
	.b-switch__switch {
		background-color: var(--color-primary-600);
	}

	.b-switch__handle {
		transform: translateX(20px);
		box-shadow: 0 0 0 2px var(--color-background-handle);
		color: var(--color-primary-600);
	}

	.b-switch__switch:hover {
		background-color: var(--color-primary-700);
	}

	.b-switch__switch:focus {
		.b-switch__handle {
			--color-background-handle: var(--color-primary-100);
		}
	}

	.b-switch__switch:active {
		.b-switch__handle {
			box-shadow: 0 0 0 4px var(--color-background-handle);
		}
	}
}

.b-switch:has(:disabled) {
	&:after {
		content: "";
		position: absolute;
		inset: 0;
		cursor: not-allowed;
	}

	.b-switch__label {
		color: var(--color-neutral-300);
	}
}
</style>
